import type { FaireProductEntity } from "../../entity_types/product";

export const p_6qgtfxpnja: FaireProductEntity = {
  token: "p_6qgtfxpnja",
  type: "product",
  name: "Brass Tray - Fortune Favours the Brave",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/65ceb8380ae999f027f9a6be84acf001671c26f82862886219d9a2414e8c38d5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aee55584f94a22f4870efdc760128be30bcd83b2925ea523efc31551b6b9e836.jpeg",
  ],
  priceDollars: 13,
  description:
    "Crafted from solid brass and engraved with the uplifting message “Fortune Favours the Brave,” this beautifully weighted tray is a daily reminder to take bold steps. Its smooth matte finish is designed to patina naturally over time, giving each piece a character all its own. Perfect as a catch-all for keys, jewellery, or desk essentials, it brings quiet encouragement and timeless style to any bedside table, hallway, or workspace.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:46.712Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
